class _ProdComparison {
  constructor(sectionId, batteryTitleId) {
    this.sectionId = sectionId;
    this.b_title_el = document.querySelector('#' + batteryTitleId);
    this.section_el = document.querySelector('.section-' + this.sectionId);
    this.float_banner_el = document.querySelector('.section-' + this.sectionId + ' .prod-float-banner');
    this.scrollX_bar_el = document.querySelector('.section-' + this.sectionId + ' .spc-scroll-progress');
    this.scrollX_bar_progress_el = document.querySelector('.section-' + this.sectionId + ' .spc-sp-progress');
    this.hiddenClassname = 'hidden-banner';
    this.displayFloatBanner();
    this.overflowX_el = document.querySelector('.section-' + this.sectionId + ' .prod-comparison-swiper-wrapper');
    this.syncOverflowX2Banner();
  }
  static throttle = (fn, wait) => {
    let inThrottle, lastFn, lastTime;
    return function () {
      const context = this,
        args = arguments;
      if (!inThrottle) {
        fn.apply(context, args);
        lastTime = Date.now();
        inThrottle = true;
      } else {
        clearTimeout(lastFn);
        lastFn = setTimeout(function () {
          if (Date.now() - lastTime >= wait) {
            fn.apply(context, args);
            lastTime = Date.now();
          }
        }, Math.max(wait - (Date.now() - lastTime), 0));
      }
    };
  };
  displayFloatBanner() {
    window.addEventListener(
      'scroll',
      _ProdComparison.throttle((e) => {
        const b_title_postion = this.b_title_el.getBoundingClientRect();
        const section_el_postion = this.section_el.getBoundingClientRect();
        
        if (b_title_postion.top < 48 && section_el_postion.bottom > 48 * 2) {
          if (this.float_banner_el.classList.contains(this.hiddenClassname)) {
            this.float_banner_el.classList.remove(this.hiddenClassname);
            this.scrollX_bar_el.classList.remove(this.hiddenClassname);
          }
        } else {
          if (this.float_banner_el.classList.contains(this.hiddenClassname) == false)
            this.float_banner_el.classList.add(this.hiddenClassname);
            this.scrollX_bar_el.classList.add(this.hiddenClassname);
        }
      }, 250)
    );
  }
  syncOverflowX2Banner() {
    this.overflowX_el.addEventListener('scroll', (e) => {
      this.float_banner_el.setAttribute('style', 'transform: translate3D(-' + this.overflowX_el.scrollLeft + 'px, 0px, 0px);');
      this.scrollX_bar_progress_el.setAttribute('style', 'width: ' + this.scrollProgressPercentWidth() + '%;')
    });
  }
  scrollProgressPercentWidth() {
    let percentage = 0;
    if (this.overflowX_el) {
      percentage = Math.round(100*this.overflowX_el.scrollLeft / (this.overflowX_el.scrollWidth - this.overflowX_el.clientWidth))
    }
    percentage = percentage < 0 ? 0 : percentage;
    percentage = percentage > 100 ? 100 : percentage;
    return percentage;
  }
}
